import { PlusIcon } from "components/icons/PlusIcon";
import { colors } from "constants/colors";

type AddEntityCardProps = {
  label: string;
  onClick: () => void;
};

// rounded dashed border (4px dash, 4px gap) — CSS border-dashed can't set the
// dash pattern on rounded corners, so draw it as an SVG rect stroke
const DASHED_BORDER = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='${encodeURIComponent(
  colors.neutral["20"]
)}' stroke-width='1.5' stroke-dasharray='4%2c 4'/%3e%3c/svg%3e")`;

export const AddEntityCard = ({ label, onClick }: AddEntityCardProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ backgroundImage: DASHED_BORDER }}
      className="all:unset t-flex t-w-full t-cursor-pointer t-items-center t-justify-center t-gap-3 t-rounded-xl t-bg-surface-transparent t-px-4 t-py-3 t-text-body t-text-text-30 t-transition-colors hover:t-text-text-60"
    >
      <PlusIcon size="12" stroke="2.1" />
      {label}
    </button>
  );
};
